<div class="container">
    <nav>
        <div class="nav nav-tabs" id="nav-tab" role="tablist">
            <button class="header-link" [class]="activeTab() === 0 ? 'show active' : ''" type="button" role="tab"
                (click)="activeTab.set(0)">Commentaires</button>
            <button class="header-link" [class]="activeTab() === 1 ? 'show active' : ''" type="button" role="tab"
                (click)="activeTab.set(1)">Reponses</button>
            <button class="header-link" [class]="activeTab() === 2 ? 'show active' : ''" data-bs-toggle="tab"
                type="button" role="tab" (click)="activeTab.set(2)">Modifications</button>
        </div>
    </nav>
    <div class="tab-content" id="nav-tabContent">
        <div class="tab-pane fade row" [class]="activeTab() === 0 ? 'show active' : ''">
            @if (!allFamiliesWithComments() || allFamiliesWithComments()!.length === 0) {
            <div class="col-12 col-lg-6 col-xxl-4 pe-2 pb-2">
                <div class="infoBlock p-3 italic bold">
                    Aucun commentaire disponible
                </div>
            </div>
            } @else {
            @for (family of allFamiliesWithComments(); track $index) {
            <div class="col-12 col-lg-6 col-xxl-4 pe-2 pb-2">
                <div class="infoBlock">
                    <p><span class="bold">De la part de :&nbsp;</span>
                        <span class="tooltip-container">
                            {{ family.persons.filter(p => p.adult).map((p, i) => (i > 0 ? 'Et\u00a0' : '') +
                            p.firstName).join(' ') }}
                            <span class="tooltip-text">{{ family.persons.filter(p => p.adult).map((p, i) => (i > 0 ?
                                'Et\u00a0' : '') + p.firstName + '\u00a0' + p.lastName).join(' ') + ' du\u00a0' +
                                family.familyDepartement}}</span>
                        </span>
                    </p>
                    <p><span class="bold">Message&nbsp;:&nbsp;</span>{{family.comment}}</p>
                    <p class="italic">{{family.invitationType}}&nbsp;{{family.staysForBrunch ? '\u00a0+\u00a0brunch' :
                        ''}}</p>
                </div>
            </div>
            }
            }
        </div>
        <div class="tab-pane fade row" [class]="activeTab() === 1 ? 'show active' : ''">
            @if (!allFamiliesWithAnswers() || allFamiliesWithAnswers()!.length === 0) {
            <div class="col-12 col-lg-6 col-xxl-4 pe-2 pb-2">
                <div class="infoBlock p-3 italic bold">
                    Aucune réponse disponible
                </div>
            </div>
            } @else {
            @for (family of allFamiliesWithAnswers(); track $index) {
            <div class="col-12 col-lg-6 col-xxl-4 pe-2 pb-2">
                <div class="infoBlock">
                    <p><span class="bold">De la part de :&nbsp;</span>
                        <span class="tooltip-container">
                            {{ family.persons.filter(p => p.adult).map((p, i) => (i > 0 ? 'Et\u00a0' : '') +
                            p.firstName).join(' ') }}
                            <span class="tooltip-text">{{ family.persons.filter(p => p.adult).map((p, i) => (i > 0 ?
                                'Et\u00a0' : '') + p.firstName + '\u00a0' + p.lastName).join(' ') + ' du\u00a0' +
                                family.familyDepartement}}</span>
                        </span>
                    </p>
                    <p><span class="bold">Reponse&nbsp;:&nbsp;</span>{{family.bonusQuestionAnswer}}</p>
                </div>
            </div>
            }
            }
        </div>
        <div class="tab-pane fade row" [class]="activeTab() === 2 ? 'show active' : ''">
            <div class="row col-12 history-filters">
                <div class="col-6">
                <ngxsmk-datepicker mode="range" [showCalendarButton]=true [value]="modificationsRange()"
                    (valueChange)="datePickerValueChange($event)">
                </ngxsmk-datepicker>
                </div>
                <div class="col-2">
                    <button class="btn btn-black" (click)="selectFilterDate(0)">Ajourd'hui</button>
                </div>
                <div class="col-2">
                    <button class="btn btn-black" (click)="selectFilterDate(1)">Hier</button>
                </div>
                <div class="col-2">
                    <button class="btn btn-black" (click)="selectFilterDate(7)">Depuis&nbsp;7j</button>
                </div>
            </div>

            @if (!shownModifications() || shownModifications()!.length === 0) {
            <div class="col-12 col-lg-6 col-xxl-4 pe-2 pb-2 mt-4">
                <div class="infoBlock p-3 italic bold">
                    Aucune modification disponible
                </div>
            </div>
            } @else {
            <div class="container">
                <div class="mt-4 p-5 align-items-center rounded-3 border shadow-lg content-container">
                    @for (modif of shownModifications(); track $index) {
                    <div class="row modification-line">
                        <div class="col-3">
                            <i class="bi bi-arrow-right-circle-fill"></i>
                            <span class="bold">{{ modif.updateDate | date: "dd MMMM yy - HH'h'mm" }}</span>
                        </div>
                        <div class="col-9">
                            <span class="bold">{{modif.updateType}}</span>
                            @if (!!modif.oldValue && modif.oldValue.length > 0) {
                            <span>&nbsp;{{modif.oldValue}}</span>
                            }
                            @if (!!modif.oldValue && modif.oldValue.length > 0 && !!modif.newValue &&
                            modif.newValue.length > 0) {
                            <span>&nbsp;par</span>
                            }
                            @if (!!modif.newValue && modif.newValue.length > 0) {
                            <span>&nbsp;{{modif.newValue}}</span>
                            }
                            <span>&nbsp;pour&nbsp;</span>
                            <span class="tooltip-container">{{modif.familyIdentifierShort}}<span
                                    class="tooltip-text">{{modif.familyIdentifierLong}}</span></span>
                            @if (modif.updateOriginAdmin) {
                            <span>&nbsp;par un admin</span>
                            } @else {
                            <span>&nbsp;depuis la page RSVP</span>
                            }
                        </div>
                    </div>
                    }
                </div>
            </div>
            }

        </div>
    </div>
</div>